import React, { Component } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { Prompt } from 'react-router';

import { get, initState } from '../../../_actions/question-library.action';

import Fields from '../Create/Fields';
import Canvas from '../Create/Canvas';
import Properties from '../Create/Properties';


class QuestionnaireBuilder extends Component {
  componentDidMount() {
    const id = this.props.match.params.id;

    this.props.dispatch(get(parseInt(id)));
  }

  componentWillUnmount() {
    this.props.dispatch(initState());
  }

  render() {
    const { promptWarning } = this.props;

    return (
      <DndProvider backend={HTML5Backend}>
        <div className="row">
          <Prompt when={promptWarning} message="Are you sure you want to exit Question Builder without saving?" />

          <div className="col-lg-3">
            <Properties />
          </div>

          <div className="col-lg-6">
            <Canvas />
          </div>

          <div className="col-lg-3">
            <Fields />
          </div>
        </div>
      </DndProvider>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    promptWarning: state.questionLibrary.promptWarning
  }
}

export default connect(mapStateToProps)(QuestionnaireBuilder);